import * as React from "react"
import { detectDeviceType, isIpad, detectSafariDesktop  } from "../../util/deviceType"
import { isMobileDevice } from "../../util/browser"
import useWindowSize from "../../hooks/useWindowSize"
import fullscreenState from "../../recoil/atoms/fullscreen"
import { useRecoilState } from "recoil"

export const useBrowserType = () => {
  const { screenSize } = useWindowSize()
  const [isTabletFullScreen] = useRecoilState(
    fullscreenState.isTabletFullScreen
  )
  const device = detectDeviceType()
  const isSafari = React.useMemo<boolean>(() => device === "IOS", [device])

  const isSafariMobile = React.useMemo<boolean>(
    () =>
      device !== "Desktop" &&
      device !== "ChromeDesktop" &&
      device !== "IOSChrome" &&
      device !== "Android" &&
      device !== "SamsungBrowser",
    [device]
  )

  const isSafariDesktop = detectSafariDesktop()

  const isMobile = React.useMemo<boolean>(
    () =>
      (device !== "Desktop" &&
        device !== "ChromeDesktop" &&
        isIpad() === false) ||
      isMobileDevice(screenSize),
    [device, screenSize]
  )

  const isLandscape = React.useMemo<boolean>(
    () =>
      device !== "Desktop" &&
      device !== "ChromeDesktop" &&
      isIpad() === false &&
      screenSize.width > screenSize.height &&
      device !== "AndroidTab",
    [device, screenSize.height, screenSize.width]
  )

  const isChromeIOS = React.useMemo<boolean>(() => {
    return device === "IOSChrome"
  }, [device])

  const isTabletView = React.useMemo<boolean>(
    () =>
      isTabletFullScreen ||
      ((device === "Desktop" || device === "ChromeDesktop") &&
        screenSize.width < 768),
    [device, screenSize, isTabletFullScreen]
  )

  const isAndroidMobile = React.useMemo(() => {
    return device === "Android" && isMobileDevice(screenSize)
  }, [device, screenSize])

  const isAndroid = React.useMemo(() => {
    return device === "Android"
  }, [device])

  const isSamsungBrowser = React.useMemo(() => {
    return device === "SamsungBrowser"
  }, [device])

  const isIOSIpad = isIpad() === true

  const isFirefox = navigator.userAgent.toLowerCase().indexOf("firefox") > -1

  const isChrome = navigator.userAgent.toLowerCase().includes("chrome");

  const isWindows = navigator.platform.indexOf("Win") > -1

  const isIOS = device === "IOS"

  const isNativeAppBrowser =
    /linkedin/i.test(navigator.userAgent) ||
    /amazonwebappplatform/i.test(navigator.userAgent) ||
    /twitter/i.test(navigator.userAgent) ||
    /instagram/i.test(navigator.userAgent)

  return {
    isSafari,
    isMobile,
    isChromeIOS,
    isLandscape,
    isTabletView,
    isSafariMobile,
    isAndroidMobile,
    isSamsungBrowser,
    isAndroid,
    isFirefox,
    isIOS,
    isWindows,
    isIOSIpad,
    isNativeAppBrowser,
    isSafariDesktop,
    isChrome
  }
}
